<template>
  <ItemListCollectionWrapper
    class="itemListWrapper"
    :collectionModule="$options.PasswordManagerAppVersionCollection"
    :defaultFilters="defaultFilters"
    defaultSortBy=""
    :refreshKey="refreshKey"
    :rowsPerPageLocalStorageKey="$options.rowsPerPageLocalStorageKey"
  >
    <template
      v-slot="slotProps"
    >
      <ItemListPagination
        :columns="$options.columns"
        :currentPageNum="slotProps.currentPageNum"
        :isLoading="slotProps.loading"
        :itemComponent="$options.AppVersionrRow"
        :itemComponentProps="itemComponentProps"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="!slotProps.loading && slotProps.showEmptyState"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount"
        @pageChange="slotProps.handlePageChange"
        @sortColumn="slotProps.handleSortColumn"
      >
        <!-- toolbar is required in order not to collapse scrollable section -->
        <template v-slot:toolbar>
          <div />
        </template>
      </ItemListPagination>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import {
  ItemListPagination,
  Types,
} from '@jumpcloud/ui-components';
import {
  LocalStorageConsts,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import AppVersionrRow from 'client/PasswordManager/Overview/PasswordManagerAppVersionItemListRow.vue';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import PasswordManagerFilters from 'client/PasswordManager/PasswordManagerFilters';

const PasswordManagerAppVersionCollection = 'PasswordManagerAppVersionCollection';

const { Column } = Types;
const columns = [
  Column({
    label: 'App Version',
    dataFieldName: 'version',
    sortable: false,
    width: '1fr',
  }),
  Column({
    label: 'Devices Count',
    dataFieldName: 'users_count',
    sortable: false,
    width: '1fr',
  }),
];

export default {
  name: 'PasswordManagerAppVersionItemList',

  components: {
    ItemListPagination,
    ItemListCollectionWrapper,
  },

  columns,
  rowsPerPageLocalStorageKey: LocalStorageConsts.passwordManagerAppVersionsRowsPerPage,
  AppVersionrRow,
  PasswordManagerAppVersionCollection,

  props: {
    os: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters(PasswordManagerAppVersionCollection, [
      'refreshKey',
    ]),

    defaultFilters() {
      return [PasswordManagerFilters.operatingSystem(this.os)];
    },

    itemComponentProps() {
      return { os: this.os };
    },
  },

  methods: {
    hasEmptyListClass(slotProps) {
      return slotProps.showEmptyState || slotProps.loading;
    },
  },
};
</script>

<style scoped>
.itemListWrapper {
  height: 30rem;
}
</style>
